import '@maxhub/max-ui/dist/styles.css';
import { MaxUI, CellAction, Panel, Grid, Container, Flex, Avatar, Typography } from "@maxhub/max-ui";
// import Icon28Placeholder from '../../../.storybook/assets/icons/icon-28-placeholder.svg';

function App() {
  return (
    <MaxUI>
      <Panel mode="secondary" className="panel">
        <Typography.Headline>
          Привет, пользователь!
        </Typography.Headline>
        <Typography.Title>
          Добро пожаловать в наше приложение.
        </Typography.Title>
        <Grid gap={12} cols={1}>
            <Container className="me">
                <Flex direction="column" align="center">
                    <Avatar.Container size={72} form="squircle" className="me__avatar">
                        <Avatar.Image src="https://sun9-21.userapi.com/1N-rJz6-7hoTDW7MhpWe19e_R_TdGV6Wu5ZC0A/67o6-apnAks.jpg" />
                    </Avatar.Container>

                    <Typography.Title>Иван Иванов</Typography.Title>
                </Flex>
            </Container>
        </Grid>
        <CellAction
          // before={<Icon28Placeholder />}
          height="normal"
          mode="primary"
          onClick={function Ki(){}}
          showChevron
          >
          Запросить данные
        </CellAction>
      </Panel>
    </MaxUI>
  );
}

export default App;
